export const blockIconsBusinessandpaymentsTimelineNew = (
	<span className='material-symbols-outlined'>timeline</span>
);
